export const ShowHideIllustration = () => (
  <svg
    width='400'
    height='300'
    viewBox='0 0 400 300'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <rect width='400' height='300' fill='#EDF2F7' />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M130.789 206.54L133.088 200.998C133.669 201.239 134.311 201.375 135 201.375H139.679V207.375H135C133.508 207.375 132.086 207.078 130.789 206.54ZM139.679 90.9375H135C133.508 90.9375 132.086 91.2343 130.789 91.7722L133.088 97.3145C133.669 97.0735 134.311 96.9375 135 96.9375H139.679V90.9375ZM124 191.653H130V196.375C130 197.064 130.136 197.706 130.377 198.287L124.835 200.586C124.297 199.289 124 197.867 124 196.375V191.653ZM124 182.209H130V172.766H124V182.209ZM124 163.322H130V153.878H124V163.322ZM124 144.434H130V134.991H124V144.434ZM124 125.547H130V116.103H124V125.547ZM124 106.659H130V101.937C130 101.248 130.136 100.606 130.377 100.025L124.835 97.7268C124.297 99.0238 124 100.446 124 101.937V106.659ZM149.036 90.9375V96.9375H158.393V90.9375H149.036ZM167.75 90.9375V96.9375H177.107V90.9375H167.75ZM186.464 90.9375V96.9375H195.821V90.9375H186.464ZM205.179 90.9375V96.9375H214.536V90.9375H205.179ZM223.893 90.9375V96.9375H233.25V90.9375H223.893ZM158.393 207.375V201.375H149.036V207.375H158.393Z'
      fill='#A0AEC0'
    />
    <path
      d='M157.176 207.375H266.8C272.392 207.375 277 202.734 277 197.102V101.211C277 95.5785 272.392 90.9375 266.8 90.9375H242.976L237.93 97.7859H266.8C268.743 97.7859 270.201 99.2548 270.201 101.211V183.08L240.398 150.226C239.711 149.49 238.689 149.086 237.689 149.155C236.829 149.203 235.995 149.594 235.405 150.226L211.072 176.232L194.156 157.19L157.176 207.375Z'
      fill='#A0AEC0'
    />
    <path
      d='M206.232 140.802C208.087 141.763 210.185 142.306 212.402 142.306C219.873 142.306 226.002 136.133 226.002 128.608C226.002 124.945 224.55 121.602 222.198 119.136L206.232 140.802Z'
      fill='#A0AEC0'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M137.788 228.617C136.014 227.3 135.639 224.791 136.949 223.012L251.577 67.4526C252.887 65.6741 255.388 65.2998 257.162 66.6166C258.935 67.9333 259.311 70.4424 258.001 72.2209L143.373 227.781C142.062 229.559 139.562 229.933 137.788 228.617Z'
      fill='#718096'
    />
  </svg>
)
